/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum LoadingCapabilitiesAvailability {
  Unknown = "unknown",
  Yes = "yes",
  No = "no",
}

export function instanceOfLoadingCapabilitiesAvailability(value: any): boolean {
  for (const key in LoadingCapabilitiesAvailability) {
    if (
      Object.prototype.hasOwnProperty.call(LoadingCapabilitiesAvailability, key)
    ) {
      if (
        LoadingCapabilitiesAvailability[
          key as keyof typeof LoadingCapabilitiesAvailability
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function LoadingCapabilitiesAvailabilityFromJSON(
  json: any,
): LoadingCapabilitiesAvailability {
  return LoadingCapabilitiesAvailabilityFromJSONTyped(json, false);
}

export function LoadingCapabilitiesAvailabilityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LoadingCapabilitiesAvailability {
  return json as LoadingCapabilitiesAvailability;
}

export function LoadingCapabilitiesAvailabilityToJSON(
  value?: LoadingCapabilitiesAvailability | null,
): any {
  return value as any;
}

export function LoadingCapabilitiesAvailabilityToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): LoadingCapabilitiesAvailability {
  return value as LoadingCapabilitiesAvailability;
}
